import { AfterViewInit, Component, ElementRef, OnInit, ChangeDetectionStrategy, inject, viewChildren } from "@angular/core";
import {ModalService} from "../../../Services/modal.service";
import {GestionService, OrderHistoryObject} from "../../../Services/gestion.service";

import {ReactiveFormsModule} from "@angular/forms";
import {MealKitStarNotationModule, MealKitTextInput} from "@yoni/mealcomponents-lib";
import {GreenActionButtonComponent} from "../../green-action-button/green-action-button.component";
import {AddCommentBody, AddRatingBody, QdmService} from "../../../Services/qdm.service";
import {AuthService} from "../../../Services/auth.service";
import {ModalCommandsHistoryComponent} from "../ModalCommandsHistory/ModalCommandsHistory.component";
import {LocalStorageHelper} from "../../../Utils/LocalStorageHelper";

@Component({
    imports: [
    ReactiveFormsModule,
    MealKitStarNotationModule,
    MealKitTextInput,
    GreenActionButtonComponent
],
    selector: "modal-order-notation",
    templateUrl: "./ModalOrderNotation.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./ModalOrderNotation.component.scss"]
})
export class ModalOrderNotationComponent implements OnInit, AfterViewInit {
  private variables = inject<any>('variables' as any);
  private modal = inject(ModalService);
  private qdm = inject(QdmService);
  private gestion = inject(GestionService);
  private auth = inject(AuthService);


  order: OrderHistoryObject | undefined = undefined;

  readonly courseNoteElements = viewChildren('courseNote', { read: ElementRef });

  readonly courseCommentElements = viewChildren('courseComment', { read: ElementRef });

  readonly courseNotes = viewChildren('courseNote', { read: MealKitStarNotationModule });

  readonly courseComment = viewChildren('courseComment', { read: MealKitTextInput });

  protected readonly JSON = JSON;

  protected comments: any = {};
  protected notes: any = {};

  ngAfterViewInit(): void {
    const rst = this.qdm.selectedRestaurantSubject.value;
    if (!rst) return;
    if (!this.order) return;

    this.comments = [];
    this.notes = [];

    this.order?.orderItems.forEach(item => {
      const commentData: string | undefined = LocalStorageHelper.order_getCourseCommentAndMail(
        rst.id,
        item.service.id,
        item.platId,
        this.order!.id
      );

      let notationData: number | undefined = LocalStorageHelper.order_getCourseNotation(rst.id, item.service.id, item.platId, this.order!.id);

      if (commentData !== undefined) {
        this.comments[item.platId] = commentData;
      }

      if (notationData) {
        this.notes[item.platId] = notationData;
      }
    });

    this.courseNoteElements().forEach((element, index) => {
      const json: any = JSON.parse(element.nativeElement.getAttribute("data-course"));
      if (this.notes[json.platId]) {
        this.courseNotes()[index].selectedStar = this.notes[json.platId];
      }

      if(this.comments[json.platId]){
        this.courseComment()[index].value = this.comments[json.platId];
        this.courseComment()[index].disabled = true;
        this.courseComment()[index].classes = "text-xs !text-gray-500";
      }
    });
  }

  ngOnInit(): void {
    this.order = this.variables.order;
    if(this.order){
      this.order.orderItems = this.order.orderItems.sort((a, b) => parseInt(a.service.sort.toString()) - parseInt(b.service.sort.toString()));
    }

    if (this.order === undefined) {
      this.close();
    }
  }

  close(ev?: MouseEvent) {
    if (!ev) {
      this.modal.close();
      this.modal.open(ModalCommandsHistoryComponent, {}, () => {});
      return;
    }

    if (ev.target === ev.currentTarget) {
      this.close();
    }
  }

  formatDate(dateString: string): string {
    return new Date(dateString).toLocaleDateString("fr-FR");
  }

  _handler_note() {
    const inst = (this as unknown as GreenActionButtonComponent);
    const modalOrderNotation: ModalOrderNotationComponent = inst.data();
    let order: OrderHistoryObject | undefined = modalOrderNotation.order;
    const rst = modalOrderNotation.qdm.selectedRestaurantSubject.value;

    inst._state.set('loading');
    inst._displayedLabel.set("Chargement...");

    if (!order) {
      inst._state.set('failed');
      inst._displayedLabel.set("La commande est nulle");

      setTimeout(() => {
        modalOrderNotation.modal.close();
      }, 2000);
      return;
    }

    if (modalOrderNotation.auth.userSubject.value === null) {
      inst._state.set('failed');
      inst._displayedLabel.set("Vous n'êtes pas connecté");

      setTimeout(() => {
        modalOrderNotation.modal.close();
      }, 2000);

      return;
    }

    if (rst === undefined) {
      inst._state.set('failed');
      inst._displayedLabel.set("Le restaurant est introuvable");

      setTimeout(() => {
        modalOrderNotation.modal.close();
      }, 2000);

      return;
    }

    inst._displayedLabel.set("Traitement en cours...");

    const notationBodies: AddRatingBody[] = [];
    const commentsBodies: AddCommentBody[] = [];

    modalOrderNotation.order?.orderItems.forEach(item => {
      const noteGiven = modalOrderNotation.getNotationFor(modalOrderNotation, item.id);

      const comment = modalOrderNotation.getCommentFor(modalOrderNotation, item.id);

      if (noteGiven > 0) {
        notationBodies.push({
          crs_id: item.platId,
          email: modalOrderNotation.auth.userSubject.value!.email,
          rating: noteGiven,
          rst_id: rst.id,
          svc_id: item.service.id
        })

        LocalStorageHelper.order_noteCourse(rst.id, item.service.id, item.platId, noteGiven, modalOrderNotation.order!.id);

      }

      if (comment && comment !== "") {
        commentsBodies.push({
          crs_id: item.platId,
          comment: comment,
          category: 2,
          categorie: 2,
          cst_id: item.service.customerId,
          email: modalOrderNotation.auth.userSubject.value!.email,
          rst_id: rst.id,
          svc_ID: item.service.id
        })

        LocalStorageHelper.order_commentCourse(rst.id, item.service.id, item.platId, comment, modalOrderNotation.order!.id);
      }

    });


    const allPromises = [
      ...notationBodies.map(body =>
        modalOrderNotation.qdm.addRating(body)
          .then(success => ({success, body}))
          .catch(() => ({success: false, body}))
      ),
      ...commentsBodies.map(body =>
        modalOrderNotation.qdm.addComment(body)
          .then(success => ({success, body}))
          .catch(() => ({success: false, body}))
      )
    ];

    Promise.all(allPromises).then(results => {
      const notPushed = results.filter(result => !result.success).map(result => result.body);

      if (notPushed.length > 0) {
        inst._state.set('failed');
        inst._displayedLabel.set(`${notPushed.length} notes n'ont pas pu être envoyées.`);
      } else {
        inst._state.set('success');
        inst._displayedLabel.set("Toutes les notes ont été envoyées avec succès.");
      }

      setTimeout(() => {
        modalOrderNotation.modal.open(ModalCommandsHistoryComponent, {}, () => {
        })
      }, 1000);
    }).catch(() => {
      inst._state.set('failed');
      inst._displayedLabel.set("Une erreur s'est produite lors de l'envoi des notes.");

      setTimeout(() => {
        modalOrderNotation.modal.close();
      }, 2000);
    });
  }

  getNotationFor(inst: ModalOrderNotationComponent, courseId: number) {
    let note: number = 0;

    inst.courseNoteElements().forEach((element, index) => {
      const json: any = JSON.parse(element.nativeElement.getAttribute("data-course"));
      if (json.id === courseId) {
        note = inst.courseNotes()[index].selectedStar;
      }
    });

    return note;
  }

  getCommentFor(inst: ModalOrderNotationComponent, courseId: number) {
    let note: string = "";

    inst.courseCommentElements().forEach((element, index) => {
      const json: any = JSON.parse(element.nativeElement.getAttribute("data-course"));
      if (json.id === courseId) {
        note = inst.courseComment()[index].value;
      }
    });

    return note;
  }

}
